import { ParsedProjectFile } from '@arpeggi/shared'
import { useQuery, UseQueryOptions } from 'react-query'
import { useParsedProjectFilesAPI } from '../api/v2/ParsedProjectFilesAPI'

export const useParsedProjectFile = ({
  projectFile,
  options
}: {
  projectFile?: File
  options?: UseQueryOptions<ParsedProjectFile>
}) => {
  const { createParsedProjectFile } = useParsedProjectFilesAPI()

  return useQuery(
    ['parsed-project-file', `${projectFile?.name}-${projectFile?.type}`],
    () => createParsedProjectFile(projectFile),
    options
  )
}
